/**
 * <AttendanceTable
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React from 'react';
import {CSVLink} from 'react-csv';
import locale from './locale.js';

class CSVTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStudentList: [],
      currentStudentListDetail: {},
      pastStudentList: [],
      pastStudentListDetail: {},
      doneFetchingCurrentStudents: false,
      doneFetchingPastStudents: false,
      customizedFields: [],
      downloaded: false,
    }
    this.csvHeader=[];
    this.csvCurrentStudentList=[];
    this.csvPastStudentList=[];
    this.currentPageForCurrentList = 1;
    this.currentPageForPastList = 1;
    this.headers = [
      {label : __('Firstname', locale), key: 'firstname'},
      {label : __('Lastname', locale), key: 'lastname'},
      {label : __('Gender', locale), key: 'gender'},
      {label : __('DOB', locale), key: 'dob'},
      {label : __('Student Phone', locale), key: 'studentPhone'},
      {label : __('Nickname', locale), key: 'nickname'},
      {label : __('Student Email', locale), key: 'studentEmail'},
      {label : __('Street', locale), key: 'street'},
      {label : __('Unit No.', locale), key: 'unitNum'},
      {label : __('City', locale), key: 'city'},
      {label : __('Province/State', locale), key: 'province'},
      {label : __('Country', locale), key: 'country'},
      {label : __('Postal Code', locale), key: 'postalCode'},
      {label : __('Remark', locale), key: 'remark'},
      {label : __('Primary Guardian Name', locale), key: 'guardian1Name'},
      {label : __('Primary Guardian Relationship', locale), key: 'guardian1Relationship'},
      {label : __('Primary Guardian Phone', locale), key: 'guardian1Phone'},
      {label : __('Primary Guardian Email', locale), key: 'guardian1Email'},
      {label : __('Secondary Guardian Name', locale), key: 'guardian2Name'},
      {label : __('Secondary Guardian Relationship', locale), key: 'guardian2Relationship'},
      {label : __('Secondary Guardian Phone', locale), key: 'guardian2Phone'},
      {label : __('Secondary Guardian Email', locale), key: 'guardian2Email'},
    ]
    this.data = [
      {
        firstname: 'Nick',
        lastname: 'Lee',
        gender: 'M',
        dob: '2001-01-01',
        studentPhone: '16047280000',
        nickname: 'Nicky',
        studentEmail: 'nicklee@gmail.com',
        street: '5611 Oak Street',
        unitNum: '#1600',
        city: 'Vancouver',
        province: 'BC',
        country: 'Canada',
        postalCode: 'V5H0A3',
        remark: 'He is interested in programming',
        guardian1Name: 'Amy Lee',
        guardian1Relationship: 'mother',
        guardian1Phone: '16043211111',
        guardian1Email: 'amylee@gmail.com',
        guardian2Name: 'John Lee',
        guardian2Relationship: 'father',
        guardian2Phone: '17789909898',
        guardian2Email: 'johnlee@gmail.cokm',
      }
    ]
    if(this.props.customFields && this.props.customFields.fields){
      this.props.customFields.fields.forEach((field)=>{
        this.headers.push({
          label : field.label, 
          key: field.label
        })
        this.data[0][field.label]='-'
      })
    }
  }

  render() {
    return (
      <div className='downloadBtnWrapper'>
        <CSVLink
          data={this.data}
          headers={this.headers}
          filename="Student-Import-Template.csv"
          className="btn btn-primary"
          target='_self'
        >
          {__('Download CSV template', locale)}
        </CSVLink>      
      </div>
    )
  }
}

export default CSVTemplate;



// WEBPACK FOOTER //
// ./src/containers/pages/ImportStudent/csvTemplate.js